import { Injectable } from '@angular/core';
import { isoStringToDate } from '@shared/utils';
import { CustomPointOfService, WeekdayIndex, WorkingTimeInfo } from '@shop/const';

@Injectable({
  providedIn: 'root',
})
export class ShopWorkingTimeService {
  getWorkingTimeInfo(shop: CustomPointOfService): WorkingTimeInfo {
    const date = shop.pickupDate ? isoStringToDate(shop.pickupDate) : new Date();
    const weekDay = WeekdayIndex[date.getDay()];
    const openingDay = shop.openingHours?.weekDayOpeningList.find((time) => time.weekDay?.toLowerCase() === weekDay);
    const { formattedWorkingTime, openingTime, closingTime, closed } = openingDay || {};

    if (!formattedWorkingTime || !openingTime || !closingTime || closed) {
      return {
        noctidial: false,
        closed: true,
        text: 'Сегодня закрыто',
      };
    }

    if (openingTime.formattedHour === closingTime.formattedHour) {
      return {
        noctidial: true,
        closed: false,
        text: 'Круглосуточно',
      };
    }

    return {
      noctidial: false,
      closed: false,
      text: formattedWorkingTime,
    };
  }
}
